import Vue from 'vue'
import XLSX from 'xlsx'

Vue.use(XLSX)